import useProductName from "brand-customization/useProductName";
const ProductName = () => useProductName();
export default ProductName;
